// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"84daea6f","703":"eb20fd69","787":"9c919a10"}[chunkId] + ".chunk.js";
};